import { HtmlHelpers } from "./HtmlHelpers";
import { ReportDateHelper } from "./KendoHelpers";

class GridRow {
    symbol: string | null = null;
    closingDate: string | null = null;
    compositeRating: number | null = null;
    earningsPerShareRating: number | null = null;
    earningsPerShareDueDate: string | null = null;
    earningsStability: number | null = null;
    relativeStrengthRating: number | null = null;
    smrRating: number | null = null;
    accumDistRating: number | null = null;
    returnOnEquity: number | null = null;
    yieldPct: number | null = null;
    debtPct: number | null = null;
    pivotNote1: string | null = null;
    pattern: string | null = null;
    stageA: string | null = null;
    pivotPoint: number | null = null;
    pivotDate: string | null = null;
    breakoutDate: string | null = null;
}

export class MarketSmithHelper {
    private static readonly GRID = '#grid';

    public dataBoundInit(marketCol: number, fundCol: number, techCol: number,
        pivotCol: number | null = null, firstSymbolRow: number = 1) {

        const data = $(MarketSmithHelper.GRID).data('kendoGrid')!.dataSource.data() as unknown as GridRow[];
        if (!data || data.length == 0) {
            return;
        }

        ReportDateHelper.showReportDate(data[0].closingDate);

        var rows = $(MarketSmithHelper.GRID).find('tr');
        rows.each((rowIndex: number, rowElement: HTMLTableRowElement) => {
            // Skip over the header row(s).
            if (rowIndex < firstSymbolRow) {
                return;
            }

            const cellElements = $(rowElement).find('td');
            const symbol = cellElements[0].innerHTML;

            const row = data.find(d => d.symbol === symbol);
            if (!row) {
                return;
            }

            const marketCell = cellElements[marketCol];
            $(marketCell).kendoTooltip({
                content: '<table>' +
                    this.getTooltipRow('Symbol', row.symbol) +
                    this.getTooltipRow('Comp Rating', row.compositeRating?.toString()) +
                    this.getTooltipRow('EPS Rating', row.earningsPerShareRating?.toString()) +
                    this.getTooltipRow('RS Rating', row.relativeStrengthRating?.toString()) +
                    this.getTooltipRow('SMR Rating', row.smrRating?.toString()) +
                    this.getTooltipRow('A/D Rating', row.accumDistRating?.toString()) +
                    '</table>',
                showOn: 'click',
            });

            const fundCell = cellElements[fundCol];
            $(fundCell).kendoTooltip({
                content: '<table>' +
                    this.getTooltipRow('Symbol', row.symbol) +
                    this.getTooltipRow('EPS Due Date',
                        HtmlHelpers.getFormattedDate(row.earningsPerShareDueDate)) +
                    this.getTooltipRow('EPS Rating', row.earningsPerShareRating?.toString()) +
                    this.getTooltipRow('SMR Rating', row.smrRating?.toString()) +
                    this.getTooltipRow('Stability', row.earningsStability?.toString()) +
                    this.getTooltipRow('ROE',
                        HtmlHelpers.getFormattedPct(row.returnOnEquity)) +
                    this.getTooltipRow('Yield',
                        HtmlHelpers.getFormattedPct(row.yieldPct)) +
                    '</table>',
                showOn: 'click',
            });

            let techCell = cellElements[techCol];
            $(techCell).kendoTooltip({
                content: '<table>' +
                    this.getTooltipRow('Symbol', row.symbol) +
                    this.getTooltipRow('Debt/Equity Ratio',
                        HtmlHelpers.getFormattedPct(row.debtPct)) +
                    this.getTooltipRow('A/D Rating', row.accumDistRating?.toString()) +
                    '</table>',
                showOn: 'click',
            });

            if (pivotCol) {
                const pivotCell = cellElements[pivotCol];
                $(pivotCell).kendoTooltip({
                    content: '<table>' +
                        this.getTooltipRow('Symbol', row.symbol) +
                        this.getTooltipRow('Pivot Note', row.pivotNote1) +
                        this.getTooltipRow('Pattern', row.pattern) +
                        this.getTooltipRow('Stage A', row.stageA) +
                        this.getTooltipRow('Pivot Point',
                            HtmlHelpers.getFormattedCurrency(row.pivotPoint)) +
                        this.getTooltipRow('Pivot Date',
                            HtmlHelpers.getFormattedDate(row.pivotDate)) +
                        this.getTooltipRow('Breakout Date',
                            HtmlHelpers.getFormattedDate(row.breakoutDate)) +
                        '</table>',
                    showOn: 'click',
                });
            }
        });
    }

    private getTooltipRow(name: string, value: string | null | undefined) {
        if (!value) {
            value = '';
        }

        return '<tr class="mah-tooltip-tr"><td class="mah-tooltip-td-left">' +
            name + '</td><td class="mah-tooltip-td-right">' +
            value + '</td></tr>';
    }
}
